export const APP_NAME = 'GigaTvMobile';

export const VF_DOMAIN = 'https://eweb8.vfd2-testnet.de';
